var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTasks = function SvgTasks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.88 113.66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7b8fb5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tareas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tasks"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.81,6.23H68.58V2.82a2,2,0,0,0-2-2H38.33a2,2,0,0,0-2,2V6.23H10.07A2.24,2.24,0,0,0,7.8,8.45V110.52a2.25,2.25,0,0,0,2.27,2.22H94.81a2.25,2.25,0,0,0,2.27-2.22V8.45A2.24,2.24,0,0,0,94.81,6.23ZM40.33,4.82H64.58v6.79H40.33ZM92.54,108.3H12.34V10.67h24v2.94a2,2,0,0,0,2,2H66.58a2,2,0,0,0,2-2V10.67h24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.26,57.48H44.59a2.27,2.27,0,0,0,0,4.54H82.26a2.27,2.27,0,0,0,0-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.08,77.7H23.67A2.27,2.27,0,0,0,21.4,80v9.08a2.26,2.26,0,0,0,2.27,2.26h9.41a2.26,2.26,0,0,0,2.27-2.26V80A2.27,2.27,0,0,0,33.08,77.7Zm-2.27,9.08H25.94V82.24h4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.08,52.58H23.67a2.26,2.26,0,0,0-2.27,2.27v9.07a2.26,2.26,0,0,0,2.27,2.27h9.41a2.26,2.26,0,0,0,2.27-2.27V54.85A2.26,2.26,0,0,0,33.08,52.58Zm-2.27,9.07H25.94V57.12h4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.08,27.47H23.67a2.27,2.27,0,0,0-2.27,2.27v9.09a2.27,2.27,0,0,0,2.27,2.27h9.42a2.27,2.27,0,0,0,2.26-2.27V29.74h0A2.27,2.27,0,0,0,33.08,27.47Zm-2.27,9.09H25.94V32h4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.26,82.58H44.59a2.27,2.27,0,1,0,0,4.54H82.26a2.27,2.27,0,1,0,0-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.59,32.38a2.27,2.27,0,1,0,0,4.54H82.26a2.27,2.27,0,0,0,0-4.54Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTasks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tasks.0c37a8b6e10bb69d4fded48a81cd9ab2.svg";